// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-shell {
  min-height: 100vh;
  background: radial-gradient(circle at 20% 20%, #eef2ff, #f8fafc);
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: #0f172a;
  display: flex;
  flex-direction: column;
}

/* ── Navigation bar ─────────────────────────────────────────────────────────── */
.app-nav {
  position: sticky;
  top: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 0 32px;
  height: 56px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 12px rgba(15, 23, 42, 0.06);
}

.app-nav-brand {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  flex-shrink: 0;
}

.app-nav-logo {
  font-size: 20px;
  line-height: 1;
}

.app-nav-title {
  font-weight: 800;
  font-size: 16px;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.app-nav-links {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1 1;
}

.nav-link {
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #475569;
  text-decoration: none;
  transition: color 0.15s ease, background 0.15s ease;
}

.nav-link:hover {
  color: #0f172a;
  background: #f1f5f9;
}

.nav-link-active {
  color: #4338ca;
  background: #eef2ff;
}

.app-nav-user {
  margin-left: auto;
  flex-shrink: 0;
}

.app-nav-email {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.app-nav-login {
  padding: 7px 16px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #ffffff;
  color: #0f172a;
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.app-nav-login:hover {
  border-color: #a5b4fc;
  background: #eef2ff;
  color: #4338ca;
}

/* ── Page content wrapper ───────────────────────────────────────────────────── */
.workspace,
.browse-page-container {
  flex: 1 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px;
  width: 100%;
  box-sizing: border-box;
}

/* ── Global error banner ────────────────────────────────────────────────────── */
.global-error {
  margin: 12px 32px 0;
}

.card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 15px 60px rgba(15, 23, 42, 0.08);
  max-width: 960px;
  margin: 0 auto;
}

.upload-card h1 {
  margin: 0 0 4px;
  font-size: 32px;
  letter-spacing: -0.02em;
}

.upload-card p {
  margin: 0;
  color: #475569;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
}

.card-header.column {
  flex-direction: column;
  align-items: flex-start;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stack {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.field label {
  font-weight: 600;
  color: #0f172a;
}

.field input,
.field textarea {
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  padding: 12px 14px;
  font-size: 14px;
  font-family: inherit;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.field input:focus,
.field textarea:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
}

.field textarea {
  resize: vertical;
  min-height: 120px;
}

.file-input {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  padding: 12px;
  background: #f8fafc;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.12s ease;
}

.file-input input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.file-input span {
  color: #475569;
  font-size: 14px;
}

.file-input:hover {
  border-color: #6366f1;
  box-shadow: 0 10px 24px rgba(99, 102, 241, 0.16);
  transform: translateY(-1px);
}

.file-input:hover span {
  color: #312e81;
}

.actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
}

.primary {
  background: linear-gradient(135deg, #6366f1, #9b71fd);
  color: white;
  padding: 12px 18px;
  border: none;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(99, 102, 241, 0.25);
  transition: transform 0.12s ease, box-shadow 0.12s ease;
}

.primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

.primary:not(:disabled):hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 36px rgba(99, 102, 241, 0.35);
}

.actions.vertical {
  flex-direction: column;
  align-items: stretch;
}

.full-width {
  width: 100%;
}

.ghost {
  background: transparent;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 10px 14px;
  font-weight: 600;
  cursor: pointer;
  color: #0f172a;
}

.progress-button {
  background: linear-gradient(135deg, #92a0b9, #bed1e1 );
  color: rgb(21, 21, 21);
  padding: 12px 18px;
  border: none;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
}

.error {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 12px;
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecdd3;
}

.info {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 12px;
  background: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
}

.hint {
  color: #475569;
  font-size: 13px;
}

/* .workspace max-width defined above in the combined rule */

.workspace-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.workspace-header h2 {
  margin: 0;
  letter-spacing: -0.01em;
}

.workspace-body {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 16px;
}

.editor-pane,
.questions-pane {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 18px;
  box-shadow: 0 15px 60px rgba(15, 23, 42, 0.04);
  min-height: 70vh;
}

.pane-title {
  font-weight: 700;
  margin-bottom: 12px;
}

.question-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 70vh;
  overflow-y: auto;
}

.question-list-actions {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 12px;
}

.question-overall-stats {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 10px 12px;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-around;
  gap: 12px;
}

.circle-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.circle-progress {
  width: 76px;
  height: 76px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle-progress-inner {
  width: 58px;
  height: 58px;
  border-radius: 999px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  font-weight: 700;
  color: #334155;
}

.circle-main-value {
  line-height: 1;
}

.circle-percentage-value {
  font-size: 10px;
  font-weight: 600;
  color: #64748b;
  line-height: 1;
}

.circle-stat-label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
}

.tree-node {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.tree-children {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.tree-branch,
.tree-leaf {
  width: 90%;
  text-align: left;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  background: #f8fafc;
  color: #0f172a;
  padding: 9px 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.tree-branch:hover,
.tree-leaf:hover {
  border-color: #cbd5e1;
  border-width: 1px;
  box-shadow: 0 0 10px 0 rgba(145, 145, 145, 0.5);
}

.tree-branch {
  flex-direction: column;
  align-items: stretch;
}

.tree-branch-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tree-branch-label {
  flex: 1 1;
}

.tree-branch-count {
  font-size: 12px;
  color: #64748b;
}

.tree-caret {
  color: #64748b;
  margin-right: 8px;
}

.tree-leaf.active {
  border-color: #6366f1;
  background: #eef2ff;
}

.tree-leaf.status-correct {
  border-color: #10b981;
  background: #ecfdf5;
}

.tree-leaf.status-incorrect {
  border-color: #ef4444;
  background: #fef2f2;
}

.tree-leaf.status-answered {
  border-color: #facc15;
  background: #fef9c3;
}

.tree-leaf.status-unanswered {
  border-color: #cbd5e1;
  background: #f1f5f9;
}

.tree-leaf-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.depth-1 {
  margin-left: 14px;
}

.depth-2 {
  margin-left: 28px;
}

.depth-3 {
  margin-left: 42px;
}

.question-chip {
  text-align: left;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px;
  background: #f8fafc;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.question-chip.active {
  border-color: #6366f1;
  background: #eef2ff;
  box-shadow: 0 8px 22px rgba(99, 102, 241, 0.15);
}

.chip-title {
  font-weight: 700;
  margin-bottom: 4px;
}

.chip-subtitle {
  color: #475569;
  font-size: 13px;
  line-height: 1.4;
}

.editor {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.empty-list,
.empty-editor {
  color: #94a3b8;
  font-size: 14px;
}

.eyebrow {
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.08em;
  color: #475569;
  margin: 0;
}

.question-chip.correct {
  border-color: #10b981;
  background: #ecfdf5;
}

.question-chip.incorrect {
  border-color: #ef4444;
  background: #fef2f2;
}

.chip-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.grade-indicator {
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
}

.grade-indicator.correct {
  color: #10b981;
}

.grade-indicator.incorrect {
  color: #ef4444;
}

.answered-circle {
  width: 12px;
  height: 12px;
  border-radius: 999px;
  background: #facc15;
  border: 1px solid #eab308;
  display: inline-block;
}

.grading-result {
  padding: 16px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  margin-top: 8px;
}

/* ── Grading feedback ───────────────────────────────────────────────────────── */
.feedback-banner {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  margin-bottom: 16px;
}

.feedback-banner.correct {
  background: linear-gradient(135deg, #ecfdf5, #f0fdfa);
  border: 1px solid #6ee7b7;
  animation: feedback-pop 0.5s ease-out;
}

.feedback-banner.incorrect {
  background: #fffbeb;
  border: 1px solid #fcd34d;
  animation: feedback-nudge 0.45s ease-out;
}

@keyframes feedback-pop {
  0% { transform: translateY(6px) scale(0.97); opacity: 0; }
  60% { transform: translateY(-2px) scale(1.01); opacity: 1; }
  100% { transform: translateY(0) scale(1); opacity: 1; }
}

@keyframes feedback-nudge {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-4px); }
  50% { transform: translateX(4px); }
  75% { transform: translateX(-2px); }
}

.feedback-banner.correct .feedback-icon {
  animation: feedback-icon-bounce 0.65s ease-out;
}

.feedback-banner.incorrect .feedback-icon {
  animation: feedback-icon-turn 0.6s ease-out;
}

@keyframes feedback-icon-bounce {
  0% { transform: scale(0.5) rotate(-15deg); }
  50% { transform: scale(1.25) rotate(10deg); }
  100% { transform: scale(1) rotate(0); }
}

@keyframes feedback-icon-turn {
  from { transform: rotate(-90deg); }
  to { transform: rotate(0); }
}

.feedback-confetti {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.feedback-confetti i {
  position: absolute;
  left: calc(8% + var(--particle) * 12%);
  top: -10px;
  width: 6px;
  height: 9px;
  border-radius: 2px;
  background: #10b981;
  opacity: 0;
  animation: feedback-confetti-fall 1s ease-out both;
  animation-delay: calc(var(--particle) * 45ms);
}

.feedback-confetti i:nth-child(3n + 2) { background: #f59e0b; }
.feedback-confetti i:nth-child(3n) { background: #38bdf8; }

@keyframes feedback-confetti-fall {
  0% { transform: translateY(0) rotate(0); opacity: 0; }
  15% { opacity: 0.8; }
  100% { transform: translateY(110px) rotate(240deg); opacity: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .feedback-banner.correct,
  .feedback-banner.incorrect,
  .feedback-banner .feedback-icon,
  .feedback-confetti i {
    animation: none;
  }

  .feedback-confetti { display: none; }
}

.feedback-icon {
  font-size: 22px;
  line-height: 1.2;
  flex-shrink: 0;
}

.feedback-text {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.feedback-headline {
  font-size: 16px;
  font-weight: 800;
  letter-spacing: -0.01em;
}

.feedback-banner.correct .feedback-headline {
  color: #065f46;
}

.feedback-banner.incorrect .feedback-headline {
  color: #92400e;
}

.feedback-subline {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
}

.feedback-rationale {
  padding: 12px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #0f172a;
  font-size: 14px;
  line-height: 1.55;
  white-space: pre-wrap;
}

.solution-details {
  margin-top: 4px;
}

.solution-details > summary {
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  color: #4338ca;
  padding: 6px 0;
  list-style: none;
}

.solution-details > summary::-webkit-details-marker {
  display: none;
}

.solution-details > summary::before {
  content: '▸ ';
}

.solution-details[open] > summary::before {
  content: '▾ ';
}

.solution-details > summary:hover {
  color: #3730a3;
}

.student-answer-display {
  padding: 12px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  color: #0f172a;
  white-space: pre-wrap;
  min-height: 60px;
}

.question-prompt-display {
  padding: 12px;
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  color: #0f172a;
  white-space: pre-wrap;
  min-height: 120px;
  line-height: 1.5;
}

.question-image-display {
  width: 100%;
  max-width: 680px;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  background: #ffffff;
  padding: 8px;
  object-fit: contain;
}

.rationale-display {
  padding: 12px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  color: #475569;
  font-size: 14px;
  line-height: 1.6;
}

.grading-summary {
  margin-top: 16px;
  padding: 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.summary-stats {
  display: flex;
  justify-content: space-around;
  gap: 16px;
}

.stat-item {
  text-align: center;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 12px;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 1000;
}

.modal-card {
  position: relative;
  width: 100%;
  max-width: 460px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 22px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.2);
}

.login-count-badge {
  position: absolute;
  top: 12px;
  left: 14px;
  font-size: 12px;
  font-weight: 700;
  color: #94a3b8;
  line-height: 1;
}

.modal-close {
  position: absolute;
  top: 8px;
  right: 10px;
  border: 0;
  background: none;
  font-size: 24px;
  line-height: 1;
  color: #94a3b8;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 8px;
}

.modal-close:hover {
  color: #0f172a;
  background: #f1f5f9;
}

.modal-card h2 {
  margin: 0 0 8px;
}

.modal-card p {
  margin: 0 0 16px;
  color: #475569;
}

.auth-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 14px;
}

.tab-active {
  border-color: #6366f1;
  color: #4338ca;
  background: #eef2ff;
}

.session-loading {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 900;
  animation: fadeIn 0.3s ease-in-out;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.toast-message {
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: #eff6ff52;
  color: #0e2465;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  padding: 10px 14px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.22);
  z-index: 1100;
  animation: toast-fade-in-out 4s ease-in-out forwards;
}

@keyframes toast-fade-in-out {
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(-6px);
  }
  12% {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
  82% {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-50%) translateY(-6px);
  }
}

/* Generate practice button (main view) */
.generate-practice-wrap {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e2e8f0;
}
.generate-practice-btn {
  width: 100%;
}

.grade-current-btn {
  align-self: flex-start;
  margin-top: 6px;
}

/* Practice view */
.practice-view {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.practice-progress-bar {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 14px 18px;
  box-shadow: 0 15px 60px rgba(15, 23, 42, 0.04);
}
.practice-progress-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.practice-progress-title {
  font-weight: 700;
  color: #0f172a;
}
.practice-progress-counter {
  font-size: 14px;
  color: #475569;
  font-weight: 600;
}
.practice-progress-accuracy {
  font-size: 14px;
  font-weight: 800;
  color: #047857;
}
.practice-progress-segments {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.practice-progress-segment {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: 1px solid #cbd5e1;
  background: #f8fafc;
  font-weight: 700;
  font-size: 14px;
  color: #475569;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}
.practice-progress-segment:hover {
  border-color: #6366f1;
  background: #eef2ff;
  color: #4338ca;
}
.practice-progress-segment.active {
  border-color: #6366f1;
  background: #6366f1;
  color: #fff;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.35);
}
.practice-progress-segment.status-correct {
  border-color: #10b981;
  background: #ecfdf5;
  color: #065f46;
}
.practice-progress-segment.active.status-correct {
  background: #10b981;
  color: #fff;
}
.practice-progress-segment.status-incorrect {
  border-color: #ef4444;
  background: #fef2f2;
  color: #991b1b;
}
.practice-progress-segment.active.status-incorrect {
  background: #ef4444;
  color: #fff;
}
.practice-progress-segment.status-answered {
  border-color: #f59e0b;
  background: #fffbeb;
  color: #92400e;
}
.practice-progress-segment.active.status-answered {
  background: #f59e0b;
  color: #fff;
}

.practice-view-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e2e8f0;
}
.practice-view-actions .primary {
  width: 100%;
}
.practice-view-actions .progress-button {
  width: 100%;
}

.practice-score-pane {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.score-card {
  border: 1px solid #c7d2fe;
  border-radius: 16px;
  background: linear-gradient(135deg, #eef2ff, #ffffff);
  padding: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
}

.score-topic {
  color: #475569;
  font-size: 13px;
  font-weight: 700;
}

.score-value {
  color: #312e81;
  font-size: 48px;
  font-weight: 900;
  line-height: 1;
}

.score-rules {
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.score-breakdown {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.score-breakdown-item {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
  padding: 10px 8px;
  text-align: center;
}

.score-breakdown-item.correct {
  background: #ecfdf5;
  border-color: #bbf7d0;
}

.score-breakdown-item.incorrect {
  background: #fef2f2;
  border-color: #fecaca;
}

.score-breakdown-value {
  display: block;
  color: #0f172a;
  font-size: 20px;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 4px;
}

.score-breakdown-label {
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

/* ── Practice sidebar insights ──────────────────────────────────────────────── */
.insights-block {
  border-top: 1px solid #e2e8f0;
  padding-top: 14px;
}

.insights-block .pane-title {
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  margin-bottom: 10px;
}

.insights-empty {
  margin: 0;
  font-size: 13px;
  color: #94a3b8;
}

.recent-topic-list,
.topic-accuracy-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.recent-topic-row,
.topic-accuracy-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  padding: 10px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  color: #0f172a;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.recent-topic-row:hover,
.topic-accuracy-row:hover {
  background: #eef2ff;
  border-color: #c7d2fe;
}

.recent-topic-name {
  font-size: 13px;
  font-weight: 700;
  line-height: 1.3;
}

.recent-topic-meta,
.topic-accuracy-meta {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
}

.topic-accuracy-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
}

.topic-accuracy-name {
  font-size: 13px;
  font-weight: 700;
  line-height: 1.3;
  min-width: 0;
}

.topic-accuracy-value {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 800;
  color: #334155;
}

.topic-accuracy-track {
  height: 6px;
}

.progress-fill.accuracy-high {
  background: linear-gradient(90deg, #34d399, #059669);
}

.progress-fill.accuracy-mid {
  background: linear-gradient(90deg, #fbbf24, #d97706);
}

.progress-fill.accuracy-low {
  background: linear-gradient(90deg, #fb7185, #e11d48);
}

.advice-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px;
  border: 1px solid #c7d2fe;
  border-radius: 12px;
  background: linear-gradient(135deg, #eef2ff, #ffffff);
}

.advice-headline {
  font-size: 14px;
  font-weight: 800;
  color: #3730a3;
  line-height: 1.3;
}

.advice-body {
  font-size: 12px;
  line-height: 1.5;
  color: #475569;
}

.advice-cta {
  margin-top: 4px;
  padding: 8px 12px;
  font-size: 12px;
}

.practice-questions-pane .practice-question-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 70vh;
  overflow-y: auto;
}
.practice-question-chip {
  text-align: left;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px;
  background: #f8fafc;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.practice-question-chip:hover {
  border-color: #cbd5e1;
}
.practice-question-chip.active {
  border-color: #6366f1;
  background: #eef2ff;
}
.practice-question-chip.status-correct {
  border-color: #10b981;
  background: #ecfdf5;
}
.practice-question-chip.status-incorrect {
  border-color: #ef4444;
  background: #fef2f2;
}
.practice-question-chip.status-answered {
  border-color: #f59e0b;
  background: #fffbeb;
}
.practice-chip-num {
  font-weight: 600;
  color: #0f172a;
  display: flex;
  align-items: baseline;
  gap: 5px;
  min-width: 0;
  overflow: hidden;
}

.practice-chip-index {
  flex-shrink: 0;
  font-size: 12px;
  color: #64748b;
  font-weight: 700;
}

.practice-chip-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}

.expected-answer-display {
  padding: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #334155;
  font-size: 14px;
  line-height: 1.5;
  white-space: pre-wrap;
}

@media (max-width: 960px) {
  .workspace-body {
    grid-template-columns: 1fr;
  }
}

/* ── Browse pages shared ────────────────────────────────────────────────────── */
.browse-page-header {
  margin-bottom: 32px;
}

.browse-page-title {
  font-size: 28px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #0f172a;
  margin: 0 0 6px;
}

.browse-page-subtitle {
  color: #475569;
  margin: 0 0 20px;
  font-size: 15px;
}

/* ── Search bar ─────────────────────────────────────────────────────────────── */
.browse-search-bar {
  position: relative;
  display: flex;
  align-items: center;
  max-width: 480px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  padding: 0 14px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.browse-search-bar:focus-within {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.18);
}

.search-icon {
  font-size: 15px;
  margin-right: 8px;
  flex-shrink: 0;
  opacity: 0.6;
}

.search-input {
  flex: 1 1;
  border: none;
  outline: none;
  padding: 11px 0;
  font-size: 14px;
  font-family: inherit;
  background: transparent;
  color: #0f172a;
}

.search-input::placeholder {
  color: #94a3b8;
}

.search-clear {
  background: none;
  border: none;
  font-size: 18px;
  line-height: 1;
  color: #94a3b8;
  cursor: pointer;
  padding: 0 2px;
  flex-shrink: 0;
}

.search-clear:hover {
  color: #475569;
}

/* ── Loading / empty states ─────────────────────────────────────────────────── */
.browse-loading {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #64748b;
  font-size: 14px;
  padding: 40px 0;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.browse-loading-spinner {
  width: 22px;
  height: 22px;
  border: 3px solid #e2e8f0;
  border-top-color: #6366f1;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  flex-shrink: 0;
}

.browse-empty {
  color: #94a3b8;
  font-size: 15px;
  padding: 48px 0;
  text-align: center;
}

/* ── Back button ────────────────────────────────────────────────────────────── */
.back-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #ffffff;
  color: #475569;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
  text-decoration: none;
  margin-bottom: 24px;
}

.back-button:hover {
  background: #f1f5f9;
  color: #0f172a;
  border-color: #cbd5e1;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

/* ── NavBar brand as button ─────────────────────────────────────────────────── */
.app-nav-brand-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

/* ── Workspace header left ──────────────────────────────────────────────────── */
.workspace-header-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.workspace-header-left .back-button {
  margin-bottom: 8px;
}

/* ── Grade level card grid ──────────────────────────────────────────────────── */
.grade-level-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
}

.grade-level-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 24px 20px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  cursor: pointer;
  text-align: left;
  transition: box-shadow 0.2s ease, transform 0.15s ease, border-color 0.2s ease;
  position: relative;
}

.grade-level-card:hover {
  box-shadow: 0 10px 32px rgba(99, 102, 241, 0.14);
  transform: translateY(-2px);
  border-color: #a5b4fc;
}

.grade-level-card-name {
  font-size: 17px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.grade-level-card-count {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.grade-level-card-arrow {
  position: absolute;
  right: 18px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #a5b4fc;
  transition: color 0.15s ease, right 0.15s ease;
}

.grade-level-card:hover .grade-level-card-arrow {
  color: #6366f1;
  right: 14px;
}

/* ── Grade Levels Page (legacy section styles kept for reference) ────────────── */
.grade-level-section {
  margin-bottom: 40px;
}

.grade-level-header {
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e2e8f0;
}

.grade-level-name {
  font-size: 20px;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.01em;
}

.grade-level-count {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.topic-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 14px;
}

.topic-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 18px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05);
  display: flex;
  flex-direction: column;
  gap: 14px;
  transition: box-shadow 0.2s ease, transform 0.15s ease, border-color 0.2s ease;
}

.topic-card:hover {
  box-shadow: 0 10px 32px rgba(99, 102, 241, 0.12);
  transform: translateY(-2px);
  border-color: #c7d2fe;
}

.topic-card-body {
  flex: 1 1;
}

.topic-card-name {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 6px;
  line-height: 1.3;
}

.topic-card-count {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.topic-card-actions {
  display: flex;
  gap: 8px;
}

.topic-practice-btn {
  flex: 1 1;
  padding: 9px 12px;
  font-size: 13px;
}

.topic-view-btn {
  flex: 1 1;
  padding: 9px 12px;
  font-size: 13px;
}

/* ── Home page hero ─────────────────────────────────────────────────────────── */
.home-page {
  flex: 1 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px;
  width: 100%;
  box-sizing: border-box;
}

.hero {
  padding: 56px 0 48px;
  max-width: 760px;
}

.hero-eyebrow {
  display: inline-block;
  padding: 5px 12px;
  border-radius: 999px;
  background: #eef2ff;
  color: #4338ca;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.01em;
  margin-bottom: 20px;
}

.hero-title {
  margin: 0 0 18px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 900;
  letter-spacing: -0.03em;
  color: #0f172a;
}

.hero-title-accent {
  color: #4338ca;
}

.hero-subtitle {
  margin: 0 0 28px;
  font-size: 18px;
  line-height: 1.55;
  color: #475569;
  max-width: 620px;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 40px;
}

.hero-cta-primary,
.hero-cta-secondary {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px 28px;
  border-radius: 12px;
  font: inherit;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.15s ease, box-shadow 0.2s ease, transform 0.15s ease,
    border-color 0.15s ease;
}

.hero-cta-primary {
  border: 1px solid #4338ca;
  background: #4338ca;
  color: #ffffff;
  box-shadow: 0 10px 28px rgba(67, 56, 202, 0.28);
}

.hero-cta-primary:hover {
  background: #3730a3;
  transform: translateY(-1px);
}

.hero-cta-secondary {
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #0f172a;
}

.hero-cta-secondary:hover {
  border-color: #a5b4fc;
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);
  transform: translateY(-1px);
}

.hero-cta-note {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  margin-top: 2px;
}

.hero-highlights {
  display: flex;
  flex-wrap: wrap;
  gap: 28px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.hero-highlights li {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #64748b;
  max-width: 200px;
}

.hero-highlights strong {
  font-size: 20px;
  font-weight: 900;
  color: #0f172a;
  letter-spacing: -0.01em;
}

/* ── Home page sections ─────────────────────────────────────────────────────── */
.home-picker,
.home-steps {
  padding: 40px 0;
  border-top: 1px solid #e2e8f0;
}

.home-section-header {
  margin-bottom: 20px;
}

.home-section-title {
  margin: 0 0 6px;
  font-size: 24px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.home-section-subtitle {
  margin: 0;
  font-size: 15px;
  color: #475569;
}

.home-steps-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
}

.home-step-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 22px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05);
}

.home-step-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: #eef2ff;
  color: #4338ca;
  font-size: 14px;
  font-weight: 800;
  margin-bottom: 12px;
}

.home-step-title {
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
}

.home-step-body {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #475569;
}

/* ── Progress bars ──────────────────────────────────────────────────────────── */
.progress-track {
  display: block;
  height: 8px;
  border-radius: 999px;
  background: #e2e8f0;
  overflow: hidden;
}

.progress-fill {
  display: block;
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #6366f1, #4338ca);
  transition: width 0.3s ease;
}

/* ── Learning path overview ─────────────────────────────────────────────────── */
.path-overview {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px 24px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px 22px;
  margin-bottom: 24px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05);
}

.path-overview-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 220px;
}

.path-overview-count {
  font-size: 17px;
  font-weight: 800;
  color: #0f172a;
}

.path-overview-hint {
  font-size: 13px;
  color: #64748b;
}

.path-overview-track {
  flex: 1 1;
  min-width: 160px;
}

.path-overview-cta {
  flex-shrink: 0;
}

/* ── Learning path cards ────────────────────────────────────────────────────── */
.learning-path {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.path-card {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) auto;
  align-items: center;
  gap: 18px;
  width: 100%;
  padding: 20px 22px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05);
  color: #0f172a;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.15s ease, border-color 0.2s ease;
}

.path-card:hover {
  border-color: #a5b4fc;
  box-shadow: 0 10px 32px rgba(99, 102, 241, 0.14);
  transform: translateY(-2px);
}

.path-card-step {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 999px;
  background: #eef2ff;
  color: #4338ca;
  font-size: 15px;
  font-weight: 800;
}

.path-card-done .path-card-step {
  background: #ecfdf5;
  color: #047857;
}

.path-card-main {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.path-card-title {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1.3;
}

.path-card-meta {
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
}

.path-card-cta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 800;
  color: #4338ca;
}

.path-card-arrow {
  transition: transform 0.15s ease;
}

.path-card:hover .path-card-arrow {
  transform: translateX(3px);
}

/* ── Skill groups (standards inside a topic) ────────────────────────────────── */
.skill-group-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.skill-group {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05);
}

.skill-group-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 22px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.skill-group-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 999px;
  background: #eef2ff;
  color: #4338ca;
  font-size: 13px;
  font-weight: 800;
}

.skill-group-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
  color: #334155;
}

.skill-list {
  display: flex;
  flex-direction: column;
}

.skill-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 18px;
  width: 100%;
  padding: 16px 22px;
  background: #ffffff;
  border: 0;
  border-bottom: 1px solid #f1f5f9;
  color: #0f172a;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease;
}

.skill-row:last-child {
  border-bottom: 0;
}

.skill-row:not(:disabled):hover {
  background: #f8fafc;
}

.skill-row:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.skill-row-main {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.skill-row-label {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.skill-row-marker {
  flex-shrink: 0;
  padding: 3px 7px;
  border-radius: 6px;
  background: #e0e7ff;
  color: #3730a3;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.2;
}

.skill-row-name {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
}

.skill-row-progress {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 320px;
}

.skill-row-track {
  flex: 1 1;
  height: 6px;
}

.skill-row-count {
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  white-space: nowrap;
}

.skill-status {
  flex-shrink: 0;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.skill-status-done {
  background: #ecfdf5;
  color: #047857;
}

.skill-status-active {
  background: #fffbeb;
  color: #b45309;
}

.skill-status-todo {
  background: #f1f5f9;
  color: #475569;
}

@media (max-width: 720px) {
  .hero-title {
    font-size: 34px;
  }

  .hero-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .path-card {
    grid-template-columns: 32px minmax(0, 1fr);
  }

  .path-card-cta {
    grid-column: 2;
  }

  .skill-row {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* ── Topics Page ────────────────────────────────────────────────────────────── */
.topics-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.topic-section {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
  transition: box-shadow 0.2s ease;
}

.topic-section:hover {
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);
}

.topic-section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border-bottom: 1px solid transparent;
}

.topic-section:has(.problem-list) .topic-section-header {
  border-bottom-color: #f1f5f9;
}

.topic-section-toggle {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 10px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  padding: 0;
  color: #0f172a;
  font-family: inherit;
  min-width: 0;
}

.topic-section-toggle:hover .topic-section-name {
  color: #4338ca;
}

.topic-caret {
  font-size: 14px;
  color: #94a3b8;
  flex-shrink: 0;
  width: 16px;
}

.topic-section-name {
  font-size: 15px;
  font-weight: 700;
  flex: 1 1;
  transition: color 0.15s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.topic-section-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.topic-grade-badge {
  font-size: 11px;
  font-weight: 600;
  color: #4338ca;
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  border-radius: 999px;
  padding: 2px 10px;
  white-space: nowrap;
}

.topic-question-count {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
}

.topic-section-source-btns {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.topic-section-practice-btn {
  padding: 8px 16px;
  font-size: 13px;
  flex-shrink: 0;
}

/* ── Problem list ───────────────────────────────────────────────────────────── */
.problem-list {
  padding: 4px 0 8px;
}

.problem-list-empty {
  padding: 12px 18px;
  color: #94a3b8;
  font-size: 14px;
}

.problem-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 18px;
  border-top: 1px solid #f1f5f9;
  transition: background 0.12s ease;
}

.problem-row:hover {
  background: #f8fafc;
}

.problem-index {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  margin-top: 1px;
}

.problem-content {
  flex: 1 1;
  min-width: 0;
}

.problem-title {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  display: block;
  margin-bottom: 3px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.problem-text {
  font-size: 14px;
  color: #0f172a;
  margin: 0;
  line-height: 1.5;
  white-space: pre-wrap;
}

/* ── Empty practice state ───────────────────────────────────────────────────── */
.empty-practice-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 80px 20px;
  text-align: center;
}

.empty-practice-state h2 {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
}

.empty-practice-state p {
  color: #475569;
  margin: 0;
  font-size: 15px;
}

.empty-practice-actions {
  display: flex;
  gap: 12px;
  margin-top: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

/* ── Responsive ─────────────────────────────────────────────────────────────── */
@media (max-width: 640px) {
  .app-nav {
    padding: 0 16px;
  }
  .workspace,
  .browse-page-container {
    padding: 20px 16px;
  }
  .topic-cards-grid {
    grid-template-columns: 1fr;
  }
  .major-topic-header {
    padding: 18px;
  }
  .sub-topic-row {
    grid-template-columns: 32px minmax(0, 1fr);
    padding: 14px 18px;
  }
  .sub-topic-count {
    grid-column: 2;
  }
  .goal-section-list {
    padding: 0 18px 14px 50px;
  }
  .goal-section-row {
    grid-template-columns: 1fr;
    gap: 4px;
  }
  .topic-section-meta {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gEAAgE;EAChE,0FAA0F;EAC1F,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA,kFAAkF;AAClF;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;EAC3B,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kFAAkF;AAClF;;EAEE,SAAO;EACP,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA,kFAAkF;AAClF;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;EAC9C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gFAAgF;AAClF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,uDAAuD;AACzD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sDAAsD;EACtD,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,4DAA4D;;AAE5D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA,kFAAkF;AAClF;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,KAAK,sCAAsC,EAAE,UAAU,EAAE;EACzD,MAAM,uCAAuC,EAAE,UAAU,EAAE;EAC3D,OAAO,iCAAiC,EAAE,UAAU,EAAE;AACxD;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;EAClC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,KAAK,oCAAoC,EAAE;EAC3C,MAAM,oCAAoC,EAAE;EAC5C,OAAO,6BAA6B,EAAE;AACxC;;AAEA;EACE,OAAO,yBAAyB,EAAE;EAClC,KAAK,oBAAoB,EAAE;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,kDAAkD;EAClD,6CAA6C;AAC/C;;AAEA,yCAAyC,mBAAmB,EAAE;AAC9D,qCAAqC,mBAAmB,EAAE;;AAE1D;EACE,KAAK,kCAAkC,EAAE,UAAU,EAAE;EACrD,MAAM,YAAY,EAAE;EACpB,OAAO,2CAA2C,EAAE,UAAU,EAAE;AAClE;;AAEA;EACE;;;;IAIE,eAAe;EACjB;;EAEA,qBAAqB,aAAa,EAAE;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;EACb,oDAAoD;AACtD;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;AACF;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,iFAAiF;AACnF;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,+CAA+C;AACjD;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,qDAAqD;EACrD,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,kFAAkF;AAClF;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,0DAA0D;AAC5D;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,kFAAkF;AAClF;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kFAAkF;AAClF;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,kFAAkF;AAClF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mGAAmG;EACnG,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,kFAAkF;AAClF;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,8EAA8E;EAC9E,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;EAChD,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA,mFAAmF;AACnF;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8EAA8E;AAChF;;AAEA;EACE,gDAAgD;EAChD,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,eAAe;AACjB;;AAEA,kFAAkF;AAClF;EACE,SAAO;EACP,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB;2BACyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA,kFAAkF;AAClF;;EAEE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kFAAkF;AAClF;EACE,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,cAAc;EACd,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA,kFAAkF;AAClF;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;;AAEA,kFAAkF;AAClF;EACE;IACE,eAAe;EACjB;EACA;;IAEE,kBAAkB;EACpB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,0CAA0C;IAC1C,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;IAC1B,QAAQ;EACV;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".app-shell {\n  min-height: 100vh;\n  background: radial-gradient(circle at 20% 20%, #eef2ff, #f8fafc);\n  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  color: #0f172a;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── Navigation bar ─────────────────────────────────────────────────────────── */\n.app-nav {\n  position: sticky;\n  top: 0;\n  z-index: 200;\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  padding: 0 32px;\n  height: 56px;\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid #e2e8f0;\n  box-shadow: 0 1px 12px rgba(15, 23, 42, 0.06);\n}\n\n.app-nav-brand {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  text-decoration: none;\n  flex-shrink: 0;\n}\n\n.app-nav-logo {\n  font-size: 20px;\n  line-height: 1;\n}\n\n.app-nav-title {\n  font-weight: 800;\n  font-size: 16px;\n  color: #0f172a;\n  letter-spacing: -0.01em;\n}\n\n.app-nav-links {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex: 1;\n}\n\n.nav-link {\n  padding: 6px 14px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #475569;\n  text-decoration: none;\n  transition: color 0.15s ease, background 0.15s ease;\n}\n\n.nav-link:hover {\n  color: #0f172a;\n  background: #f1f5f9;\n}\n\n.nav-link-active {\n  color: #4338ca;\n  background: #eef2ff;\n}\n\n.app-nav-user {\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.app-nav-email {\n  font-size: 13px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.app-nav-login {\n  padding: 7px 16px;\n  border: 1px solid #cbd5e1;\n  border-radius: 9px;\n  background: #ffffff;\n  color: #0f172a;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.app-nav-login:hover {\n  border-color: #a5b4fc;\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n/* ── Page content wrapper ───────────────────────────────────────────────────── */\n.workspace,\n.browse-page-container {\n  flex: 1;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 32px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* ── Global error banner ────────────────────────────────────────────────────── */\n.global-error {\n  margin: 12px 32px 0;\n}\n\n.card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 15px 60px rgba(15, 23, 42, 0.08);\n  max-width: 960px;\n  margin: 0 auto;\n}\n\n.upload-card h1 {\n  margin: 0 0 4px;\n  font-size: 32px;\n  letter-spacing: -0.02em;\n}\n\n.upload-card p {\n  margin: 0;\n  color: #475569;\n}\n\n.card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.card-header.column {\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.stack {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.field label {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.field input,\n.field textarea {\n  border: 1px solid #cbd5e1;\n  border-radius: 12px;\n  padding: 12px 14px;\n  font-size: 14px;\n  font-family: inherit;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.field input:focus,\n.field textarea:focus {\n  outline: none;\n  border-color: #6366f1;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);\n}\n\n.field textarea {\n  resize: vertical;\n  min-height: 120px;\n}\n\n.file-input {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border: 1px dashed #cbd5e1;\n  border-radius: 12px;\n  padding: 12px;\n  background: #f8fafc;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.12s ease;\n}\n\n.file-input input {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.file-input span {\n  color: #475569;\n  font-size: 14px;\n}\n\n.file-input:hover {\n  border-color: #6366f1;\n  box-shadow: 0 10px 24px rgba(99, 102, 241, 0.16);\n  transform: translateY(-1px);\n}\n\n.file-input:hover span {\n  color: #312e81;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.primary {\n  background: linear-gradient(135deg, #6366f1, #9b71fd);\n  color: white;\n  padding: 12px 18px;\n  border: none;\n  border-radius: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 10px 30px rgba(99, 102, 241, 0.25);\n  transition: transform 0.12s ease, box-shadow 0.12s ease;\n}\n\n.primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.primary:not(:disabled):hover {\n  transform: translateY(-1px);\n  box-shadow: 0 14px 36px rgba(99, 102, 241, 0.35);\n}\n\n.actions.vertical {\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.full-width {\n  width: 100%;\n}\n\n.ghost {\n  background: transparent;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 10px 14px;\n  font-weight: 600;\n  cursor: pointer;\n  color: #0f172a;\n}\n\n.progress-button {\n  background: linear-gradient(135deg, #92a0b9, #bed1e1 );\n  color: rgb(21, 21, 21);\n  padding: 12px 18px;\n  border: none;\n  border-radius: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.error {\n  margin-top: 12px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecdd3;\n}\n\n.info {\n  margin-top: 12px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  border: 1px solid #bfdbfe;\n}\n\n.hint {\n  color: #475569;\n  font-size: 13px;\n}\n\n/* .workspace max-width defined above in the combined rule */\n\n.workspace-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.workspace-header h2 {\n  margin: 0;\n  letter-spacing: -0.01em;\n}\n\n.workspace-body {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 16px;\n}\n\n.editor-pane,\n.questions-pane {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 18px;\n  box-shadow: 0 15px 60px rgba(15, 23, 42, 0.04);\n  min-height: 70vh;\n}\n\n.pane-title {\n  font-weight: 700;\n  margin-bottom: 12px;\n}\n\n.question-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.question-list-actions {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.question-overall-stats {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n  padding: 10px 12px;\n  margin-bottom: 12px;\n  display: flex;\n  justify-content: space-around;\n  gap: 12px;\n}\n\n.circle-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n\n.circle-progress {\n  width: 76px;\n  height: 76px;\n  border-radius: 999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.circle-progress-inner {\n  width: 58px;\n  height: 58px;\n  border-radius: 999px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 2px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #334155;\n}\n\n.circle-main-value {\n  line-height: 1;\n}\n\n.circle-percentage-value {\n  font-size: 10px;\n  font-weight: 600;\n  color: #64748b;\n  line-height: 1;\n}\n\n.circle-stat-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #475569;\n}\n\n.tree-node {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.tree-children {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.tree-branch,\n.tree-leaf {\n  width: 90%;\n  text-align: left;\n  border: 1px solid #e2e8f0;\n  border-radius: 5px;\n  background: #f8fafc;\n  color: #0f172a;\n  padding: 9px 10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.tree-branch:hover,\n.tree-leaf:hover {\n  border-color: #cbd5e1;\n  border-width: 1px;\n  box-shadow: 0 0 10px 0 rgba(145, 145, 145, 0.5);\n}\n\n.tree-branch {\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.tree-branch-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tree-branch-label {\n  flex: 1;\n}\n\n.tree-branch-count {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.tree-caret {\n  color: #64748b;\n  margin-right: 8px;\n}\n\n.tree-leaf.active {\n  border-color: #6366f1;\n  background: #eef2ff;\n}\n\n.tree-leaf.status-correct {\n  border-color: #10b981;\n  background: #ecfdf5;\n}\n\n.tree-leaf.status-incorrect {\n  border-color: #ef4444;\n  background: #fef2f2;\n}\n\n.tree-leaf.status-answered {\n  border-color: #facc15;\n  background: #fef9c3;\n}\n\n.tree-leaf.status-unanswered {\n  border-color: #cbd5e1;\n  background: #f1f5f9;\n}\n\n.tree-leaf-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.depth-1 {\n  margin-left: 14px;\n}\n\n.depth-2 {\n  margin-left: 28px;\n}\n\n.depth-3 {\n  margin-left: 42px;\n}\n\n.question-chip {\n  text-align: left;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 12px;\n  background: #f8fafc;\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n}\n\n.question-chip.active {\n  border-color: #6366f1;\n  background: #eef2ff;\n  box-shadow: 0 8px 22px rgba(99, 102, 241, 0.15);\n}\n\n.chip-title {\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n\n.chip-subtitle {\n  color: #475569;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.editor {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.empty-list,\n.empty-editor {\n  color: #94a3b8;\n  font-size: 14px;\n}\n\n.eyebrow {\n  text-transform: uppercase;\n  font-size: 12px;\n  letter-spacing: 0.08em;\n  color: #475569;\n  margin: 0;\n}\n\n.question-chip.correct {\n  border-color: #10b981;\n  background: #ecfdf5;\n}\n\n.question-chip.incorrect {\n  border-color: #ef4444;\n  background: #fef2f2;\n}\n\n.chip-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.grade-indicator {\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.grade-indicator.correct {\n  color: #10b981;\n}\n\n.grade-indicator.incorrect {\n  color: #ef4444;\n}\n\n.answered-circle {\n  width: 12px;\n  height: 12px;\n  border-radius: 999px;\n  background: #facc15;\n  border: 1px solid #eab308;\n  display: inline-block;\n}\n\n.grading-result {\n  padding: 16px;\n  border-radius: 12px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  margin-top: 8px;\n}\n\n/* ── Grading feedback ───────────────────────────────────────────────────────── */\n.feedback-banner {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  margin-bottom: 16px;\n}\n\n.feedback-banner.correct {\n  background: linear-gradient(135deg, #ecfdf5, #f0fdfa);\n  border: 1px solid #6ee7b7;\n  animation: feedback-pop 0.5s ease-out;\n}\n\n.feedback-banner.incorrect {\n  background: #fffbeb;\n  border: 1px solid #fcd34d;\n  animation: feedback-nudge 0.45s ease-out;\n}\n\n@keyframes feedback-pop {\n  0% { transform: translateY(6px) scale(0.97); opacity: 0; }\n  60% { transform: translateY(-2px) scale(1.01); opacity: 1; }\n  100% { transform: translateY(0) scale(1); opacity: 1; }\n}\n\n@keyframes feedback-nudge {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-4px); }\n  50% { transform: translateX(4px); }\n  75% { transform: translateX(-2px); }\n}\n\n.feedback-banner.correct .feedback-icon {\n  animation: feedback-icon-bounce 0.65s ease-out;\n}\n\n.feedback-banner.incorrect .feedback-icon {\n  animation: feedback-icon-turn 0.6s ease-out;\n}\n\n@keyframes feedback-icon-bounce {\n  0% { transform: scale(0.5) rotate(-15deg); }\n  50% { transform: scale(1.25) rotate(10deg); }\n  100% { transform: scale(1) rotate(0); }\n}\n\n@keyframes feedback-icon-turn {\n  from { transform: rotate(-90deg); }\n  to { transform: rotate(0); }\n}\n\n.feedback-confetti {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n\n.feedback-confetti i {\n  position: absolute;\n  left: calc(8% + var(--particle) * 12%);\n  top: -10px;\n  width: 6px;\n  height: 9px;\n  border-radius: 2px;\n  background: #10b981;\n  opacity: 0;\n  animation: feedback-confetti-fall 1s ease-out both;\n  animation-delay: calc(var(--particle) * 45ms);\n}\n\n.feedback-confetti i:nth-child(3n + 2) { background: #f59e0b; }\n.feedback-confetti i:nth-child(3n) { background: #38bdf8; }\n\n@keyframes feedback-confetti-fall {\n  0% { transform: translateY(0) rotate(0); opacity: 0; }\n  15% { opacity: 0.8; }\n  100% { transform: translateY(110px) rotate(240deg); opacity: 0; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .feedback-banner.correct,\n  .feedback-banner.incorrect,\n  .feedback-banner .feedback-icon,\n  .feedback-confetti i {\n    animation: none;\n  }\n\n  .feedback-confetti { display: none; }\n}\n\n.feedback-icon {\n  font-size: 22px;\n  line-height: 1.2;\n  flex-shrink: 0;\n}\n\n.feedback-text {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n}\n\n.feedback-headline {\n  font-size: 16px;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n}\n\n.feedback-banner.correct .feedback-headline {\n  color: #065f46;\n}\n\n.feedback-banner.incorrect .feedback-headline {\n  color: #92400e;\n}\n\n.feedback-subline {\n  font-size: 13px;\n  font-weight: 600;\n  color: #475569;\n}\n\n.feedback-rationale {\n  padding: 12px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  color: #0f172a;\n  font-size: 14px;\n  line-height: 1.55;\n  white-space: pre-wrap;\n}\n\n.solution-details {\n  margin-top: 4px;\n}\n\n.solution-details > summary {\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 700;\n  color: #4338ca;\n  padding: 6px 0;\n  list-style: none;\n}\n\n.solution-details > summary::-webkit-details-marker {\n  display: none;\n}\n\n.solution-details > summary::before {\n  content: '▸ ';\n}\n\n.solution-details[open] > summary::before {\n  content: '▾ ';\n}\n\n.solution-details > summary:hover {\n  color: #3730a3;\n}\n\n.student-answer-display {\n  padding: 12px;\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  color: #0f172a;\n  white-space: pre-wrap;\n  min-height: 60px;\n}\n\n.question-prompt-display {\n  padding: 12px;\n  background: #f8fafc;\n  border: 1px solid #cbd5e1;\n  border-radius: 12px;\n  color: #0f172a;\n  white-space: pre-wrap;\n  min-height: 120px;\n  line-height: 1.5;\n}\n\n.question-image-display {\n  width: 100%;\n  max-width: 680px;\n  border: 1px solid #cbd5e1;\n  border-radius: 12px;\n  background: #ffffff;\n  padding: 8px;\n  object-fit: contain;\n}\n\n.rationale-display {\n  padding: 12px;\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  color: #475569;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.grading-summary {\n  margin-top: 16px;\n  padding: 16px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n}\n\n.summary-stats {\n  display: flex;\n  justify-content: space-around;\n  gap: 16px;\n}\n\n.stat-item {\n  text-align: center;\n}\n\n.stat-value {\n  font-size: 24px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 4px;\n}\n\n.stat-label {\n  font-size: 12px;\n  color: #475569;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.5);\n  backdrop-filter: blur(2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  z-index: 1000;\n}\n\n.modal-card {\n  position: relative;\n  width: 100%;\n  max-width: 460px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 22px;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.2);\n}\n\n.login-count-badge {\n  position: absolute;\n  top: 12px;\n  left: 14px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #94a3b8;\n  line-height: 1;\n}\n\n.modal-close {\n  position: absolute;\n  top: 8px;\n  right: 10px;\n  border: 0;\n  background: none;\n  font-size: 24px;\n  line-height: 1;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 8px;\n}\n\n.modal-close:hover {\n  color: #0f172a;\n  background: #f1f5f9;\n}\n\n.modal-card h2 {\n  margin: 0 0 8px;\n}\n\n.modal-card p {\n  margin: 0 0 16px;\n  color: #475569;\n}\n\n.auth-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 14px;\n}\n\n.tab-active {\n  border-color: #6366f1;\n  color: #4338ca;\n  background: #eef2ff;\n}\n\n.session-loading {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 900;\n  animation: fadeIn 0.3s ease-in-out;\n}\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.toast-message {\n  position: fixed;\n  top: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #eff6ff52;\n  color: #0e2465;\n  border: 1px solid #bfdbfe;\n  border-radius: 10px;\n  padding: 10px 14px;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.22);\n  z-index: 1100;\n  animation: toast-fade-in-out 4s ease-in-out forwards;\n}\n\n@keyframes toast-fade-in-out {\n  0% {\n    opacity: 0;\n    transform: translateX(-50%) translateY(-6px);\n  }\n  12% {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n  82% {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n  100% {\n    opacity: 0;\n    transform: translateX(-50%) translateY(-6px);\n  }\n}\n\n/* Generate practice button (main view) */\n.generate-practice-wrap {\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid #e2e8f0;\n}\n.generate-practice-btn {\n  width: 100%;\n}\n\n.grade-current-btn {\n  align-self: flex-start;\n  margin-top: 6px;\n}\n\n/* Practice view */\n.practice-view {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.practice-progress-bar {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 14px 18px;\n  box-shadow: 0 15px 60px rgba(15, 23, 42, 0.04);\n}\n.practice-progress-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n.practice-progress-title {\n  font-weight: 700;\n  color: #0f172a;\n}\n.practice-progress-counter {\n  font-size: 14px;\n  color: #475569;\n  font-weight: 600;\n}\n.practice-progress-accuracy {\n  font-size: 14px;\n  font-weight: 800;\n  color: #047857;\n}\n.practice-progress-segments {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.practice-progress-segment {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  border: 1px solid #cbd5e1;\n  background: #f8fafc;\n  font-weight: 700;\n  font-size: 14px;\n  color: #475569;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n.practice-progress-segment:hover {\n  border-color: #6366f1;\n  background: #eef2ff;\n  color: #4338ca;\n}\n.practice-progress-segment.active {\n  border-color: #6366f1;\n  background: #6366f1;\n  color: #fff;\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.35);\n}\n.practice-progress-segment.status-correct {\n  border-color: #10b981;\n  background: #ecfdf5;\n  color: #065f46;\n}\n.practice-progress-segment.active.status-correct {\n  background: #10b981;\n  color: #fff;\n}\n.practice-progress-segment.status-incorrect {\n  border-color: #ef4444;\n  background: #fef2f2;\n  color: #991b1b;\n}\n.practice-progress-segment.active.status-incorrect {\n  background: #ef4444;\n  color: #fff;\n}\n.practice-progress-segment.status-answered {\n  border-color: #f59e0b;\n  background: #fffbeb;\n  color: #92400e;\n}\n.practice-progress-segment.active.status-answered {\n  background: #f59e0b;\n  color: #fff;\n}\n\n.practice-view-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid #e2e8f0;\n}\n.practice-view-actions .primary {\n  width: 100%;\n}\n.practice-view-actions .progress-button {\n  width: 100%;\n}\n\n.practice-score-pane {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.score-card {\n  border: 1px solid #c7d2fe;\n  border-radius: 16px;\n  background: linear-gradient(135deg, #eef2ff, #ffffff);\n  padding: 18px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  text-align: center;\n}\n\n.score-topic {\n  color: #475569;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.score-value {\n  color: #312e81;\n  font-size: 48px;\n  font-weight: 900;\n  line-height: 1;\n}\n\n.score-rules {\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.score-breakdown {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n}\n\n.score-breakdown-item {\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #f8fafc;\n  padding: 10px 8px;\n  text-align: center;\n}\n\n.score-breakdown-item.correct {\n  background: #ecfdf5;\n  border-color: #bbf7d0;\n}\n\n.score-breakdown-item.incorrect {\n  background: #fef2f2;\n  border-color: #fecaca;\n}\n\n.score-breakdown-value {\n  display: block;\n  color: #0f172a;\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 1;\n  margin-bottom: 4px;\n}\n\n.score-breakdown-label {\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n/* ── Practice sidebar insights ──────────────────────────────────────────────── */\n.insights-block {\n  border-top: 1px solid #e2e8f0;\n  padding-top: 14px;\n}\n\n.insights-block .pane-title {\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #64748b;\n  margin-bottom: 10px;\n}\n\n.insights-empty {\n  margin: 0;\n  font-size: 13px;\n  color: #94a3b8;\n}\n\n.recent-topic-list,\n.topic-accuracy-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.recent-topic-row,\n.topic-accuracy-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n  padding: 10px 12px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  color: #0f172a;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.recent-topic-row:hover,\n.topic-accuracy-row:hover {\n  background: #eef2ff;\n  border-color: #c7d2fe;\n}\n\n.recent-topic-name {\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.recent-topic-meta,\n.topic-accuracy-meta {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.topic-accuracy-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.topic-accuracy-name {\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1.3;\n  min-width: 0;\n}\n\n.topic-accuracy-value {\n  flex-shrink: 0;\n  font-size: 13px;\n  font-weight: 800;\n  color: #334155;\n}\n\n.topic-accuracy-track {\n  height: 6px;\n}\n\n.progress-fill.accuracy-high {\n  background: linear-gradient(90deg, #34d399, #059669);\n}\n\n.progress-fill.accuracy-mid {\n  background: linear-gradient(90deg, #fbbf24, #d97706);\n}\n\n.progress-fill.accuracy-low {\n  background: linear-gradient(90deg, #fb7185, #e11d48);\n}\n\n.advice-card {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 14px;\n  border: 1px solid #c7d2fe;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #eef2ff, #ffffff);\n}\n\n.advice-headline {\n  font-size: 14px;\n  font-weight: 800;\n  color: #3730a3;\n  line-height: 1.3;\n}\n\n.advice-body {\n  font-size: 12px;\n  line-height: 1.5;\n  color: #475569;\n}\n\n.advice-cta {\n  margin-top: 4px;\n  padding: 8px 12px;\n  font-size: 12px;\n}\n\n.practice-questions-pane .practice-question-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n.practice-question-chip {\n  text-align: left;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 12px;\n  background: #f8fafc;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n.practice-question-chip:hover {\n  border-color: #cbd5e1;\n}\n.practice-question-chip.active {\n  border-color: #6366f1;\n  background: #eef2ff;\n}\n.practice-question-chip.status-correct {\n  border-color: #10b981;\n  background: #ecfdf5;\n}\n.practice-question-chip.status-incorrect {\n  border-color: #ef4444;\n  background: #fef2f2;\n}\n.practice-question-chip.status-answered {\n  border-color: #f59e0b;\n  background: #fffbeb;\n}\n.practice-chip-num {\n  font-weight: 600;\n  color: #0f172a;\n  display: flex;\n  align-items: baseline;\n  gap: 5px;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.practice-chip-index {\n  flex-shrink: 0;\n  font-size: 12px;\n  color: #64748b;\n  font-weight: 700;\n}\n\n.practice-chip-title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 13px;\n}\n\n.expected-answer-display {\n  padding: 12px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  color: #334155;\n  font-size: 14px;\n  line-height: 1.5;\n  white-space: pre-wrap;\n}\n\n@media (max-width: 960px) {\n  .workspace-body {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ── Browse pages shared ────────────────────────────────────────────────────── */\n.browse-page-header {\n  margin-bottom: 32px;\n}\n\n.browse-page-title {\n  font-size: 28px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n  margin: 0 0 6px;\n}\n\n.browse-page-subtitle {\n  color: #475569;\n  margin: 0 0 20px;\n  font-size: 15px;\n}\n\n/* ── Search bar ─────────────────────────────────────────────────────────────── */\n.browse-search-bar {\n  position: relative;\n  display: flex;\n  align-items: center;\n  max-width: 480px;\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n  border-radius: 12px;\n  padding: 0 14px;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.browse-search-bar:focus-within {\n  border-color: #6366f1;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.18);\n}\n\n.search-icon {\n  font-size: 15px;\n  margin-right: 8px;\n  flex-shrink: 0;\n  opacity: 0.6;\n}\n\n.search-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  padding: 11px 0;\n  font-size: 14px;\n  font-family: inherit;\n  background: transparent;\n  color: #0f172a;\n}\n\n.search-input::placeholder {\n  color: #94a3b8;\n}\n\n.search-clear {\n  background: none;\n  border: none;\n  font-size: 18px;\n  line-height: 1;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 0 2px;\n  flex-shrink: 0;\n}\n\n.search-clear:hover {\n  color: #475569;\n}\n\n/* ── Loading / empty states ─────────────────────────────────────────────────── */\n.browse-loading {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #64748b;\n  font-size: 14px;\n  padding: 40px 0;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.browse-loading-spinner {\n  width: 22px;\n  height: 22px;\n  border: 3px solid #e2e8f0;\n  border-top-color: #6366f1;\n  border-radius: 50%;\n  animation: spin 0.7s linear infinite;\n  flex-shrink: 0;\n}\n\n.browse-empty {\n  color: #94a3b8;\n  font-size: 15px;\n  padding: 48px 0;\n  text-align: center;\n}\n\n/* ── Back button ────────────────────────────────────────────────────────────── */\n.back-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #ffffff;\n  color: #475569;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n  text-decoration: none;\n  margin-bottom: 24px;\n}\n\n.back-button:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n  border-color: #cbd5e1;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);\n}\n\n/* ── NavBar brand as button ─────────────────────────────────────────────────── */\n.app-nav-brand-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n}\n\n/* ── Workspace header left ──────────────────────────────────────────────────── */\n.workspace-header-left {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.workspace-header-left .back-button {\n  margin-bottom: 8px;\n}\n\n/* ── Grade level card grid ──────────────────────────────────────────────────── */\n.grade-level-cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 16px;\n}\n\n.grade-level-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 24px 20px;\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n  cursor: pointer;\n  text-align: left;\n  transition: box-shadow 0.2s ease, transform 0.15s ease, border-color 0.2s ease;\n  position: relative;\n}\n\n.grade-level-card:hover {\n  box-shadow: 0 10px 32px rgba(99, 102, 241, 0.14);\n  transform: translateY(-2px);\n  border-color: #a5b4fc;\n}\n\n.grade-level-card-name {\n  font-size: 17px;\n  font-weight: 800;\n  color: #0f172a;\n  letter-spacing: -0.01em;\n}\n\n.grade-level-card-count {\n  font-size: 13px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.grade-level-card-arrow {\n  position: absolute;\n  right: 18px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 18px;\n  color: #a5b4fc;\n  transition: color 0.15s ease, right 0.15s ease;\n}\n\n.grade-level-card:hover .grade-level-card-arrow {\n  color: #6366f1;\n  right: 14px;\n}\n\n/* ── Grade Levels Page (legacy section styles kept for reference) ────────────── */\n.grade-level-section {\n  margin-bottom: 40px;\n}\n\n.grade-level-header {\n  display: flex;\n  align-items: baseline;\n  gap: 12px;\n  margin-bottom: 16px;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.grade-level-name {\n  font-size: 20px;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 0;\n  letter-spacing: -0.01em;\n}\n\n.grade-level-count {\n  font-size: 13px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.topic-cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 14px;\n}\n\n.topic-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 18px;\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05);\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  transition: box-shadow 0.2s ease, transform 0.15s ease, border-color 0.2s ease;\n}\n\n.topic-card:hover {\n  box-shadow: 0 10px 32px rgba(99, 102, 241, 0.12);\n  transform: translateY(-2px);\n  border-color: #c7d2fe;\n}\n\n.topic-card-body {\n  flex: 1;\n}\n\n.topic-card-name {\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 6px;\n  line-height: 1.3;\n}\n\n.topic-card-count {\n  font-size: 12px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.topic-card-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.topic-practice-btn {\n  flex: 1;\n  padding: 9px 12px;\n  font-size: 13px;\n}\n\n.topic-view-btn {\n  flex: 1;\n  padding: 9px 12px;\n  font-size: 13px;\n}\n\n/* ── Home page hero ─────────────────────────────────────────────────────────── */\n.home-page {\n  flex: 1;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 32px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.hero {\n  padding: 56px 0 48px;\n  max-width: 760px;\n}\n\n.hero-eyebrow {\n  display: inline-block;\n  padding: 5px 12px;\n  border-radius: 999px;\n  background: #eef2ff;\n  color: #4338ca;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  margin-bottom: 20px;\n}\n\n.hero-title {\n  margin: 0 0 18px;\n  font-size: 48px;\n  line-height: 1.1;\n  font-weight: 900;\n  letter-spacing: -0.03em;\n  color: #0f172a;\n}\n\n.hero-title-accent {\n  color: #4338ca;\n}\n\n.hero-subtitle {\n  margin: 0 0 28px;\n  font-size: 18px;\n  line-height: 1.55;\n  color: #475569;\n  max-width: 620px;\n}\n\n.hero-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 40px;\n}\n\n.hero-cta-primary,\n.hero-cta-secondary {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 15px 28px;\n  border-radius: 12px;\n  font: inherit;\n  font-size: 16px;\n  font-weight: 800;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background 0.15s ease, box-shadow 0.2s ease, transform 0.15s ease,\n    border-color 0.15s ease;\n}\n\n.hero-cta-primary {\n  border: 1px solid #4338ca;\n  background: #4338ca;\n  color: #ffffff;\n  box-shadow: 0 10px 28px rgba(67, 56, 202, 0.28);\n}\n\n.hero-cta-primary:hover {\n  background: #3730a3;\n  transform: translateY(-1px);\n}\n\n.hero-cta-secondary {\n  border: 1px solid #cbd5e1;\n  background: #ffffff;\n  color: #0f172a;\n}\n\n.hero-cta-secondary:hover {\n  border-color: #a5b4fc;\n  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);\n  transform: translateY(-1px);\n}\n\n.hero-cta-note {\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  margin-top: 2px;\n}\n\n.hero-highlights {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 28px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.hero-highlights li {\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n  color: #64748b;\n  max-width: 200px;\n}\n\n.hero-highlights strong {\n  font-size: 20px;\n  font-weight: 900;\n  color: #0f172a;\n  letter-spacing: -0.01em;\n}\n\n/* ── Home page sections ─────────────────────────────────────────────────────── */\n.home-picker,\n.home-steps {\n  padding: 40px 0;\n  border-top: 1px solid #e2e8f0;\n}\n\n.home-section-header {\n  margin-bottom: 20px;\n}\n\n.home-section-title {\n  margin: 0 0 6px;\n  font-size: 24px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n}\n\n.home-section-subtitle {\n  margin: 0;\n  font-size: 15px;\n  color: #475569;\n}\n\n.home-steps-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 16px;\n}\n\n.home-step-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 22px;\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05);\n}\n\n.home-step-number {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 999px;\n  background: #eef2ff;\n  color: #4338ca;\n  font-size: 14px;\n  font-weight: 800;\n  margin-bottom: 12px;\n}\n\n.home-step-title {\n  margin: 0 0 6px;\n  font-size: 16px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.home-step-body {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #475569;\n}\n\n/* ── Progress bars ──────────────────────────────────────────────────────────── */\n.progress-track {\n  display: block;\n  height: 8px;\n  border-radius: 999px;\n  background: #e2e8f0;\n  overflow: hidden;\n}\n\n.progress-fill {\n  display: block;\n  height: 100%;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #6366f1, #4338ca);\n  transition: width 0.3s ease;\n}\n\n/* ── Learning path overview ─────────────────────────────────────────────────── */\n.path-overview {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 16px 24px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 20px 22px;\n  margin-bottom: 24px;\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05);\n}\n\n.path-overview-text {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 220px;\n}\n\n.path-overview-count {\n  font-size: 17px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.path-overview-hint {\n  font-size: 13px;\n  color: #64748b;\n}\n\n.path-overview-track {\n  flex: 1;\n  min-width: 160px;\n}\n\n.path-overview-cta {\n  flex-shrink: 0;\n}\n\n/* ── Learning path cards ────────────────────────────────────────────────────── */\n.learning-path {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.path-card {\n  display: grid;\n  grid-template-columns: 40px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 18px;\n  width: 100%;\n  padding: 20px 22px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05);\n  color: #0f172a;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: box-shadow 0.2s ease, transform 0.15s ease, border-color 0.2s ease;\n}\n\n.path-card:hover {\n  border-color: #a5b4fc;\n  box-shadow: 0 10px 32px rgba(99, 102, 241, 0.14);\n  transform: translateY(-2px);\n}\n\n.path-card-step {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 999px;\n  background: #eef2ff;\n  color: #4338ca;\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.path-card-done .path-card-step {\n  background: #ecfdf5;\n  color: #047857;\n}\n\n.path-card-main {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.path-card-title {\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  line-height: 1.3;\n}\n\n.path-card-meta {\n  font-size: 13px;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.path-card-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  font-size: 14px;\n  font-weight: 800;\n  color: #4338ca;\n}\n\n.path-card-arrow {\n  transition: transform 0.15s ease;\n}\n\n.path-card:hover .path-card-arrow {\n  transform: translateX(3px);\n}\n\n/* ── Skill groups (standards inside a topic) ────────────────────────────────── */\n.skill-group-list {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.skill-group {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05);\n}\n\n.skill-group-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 18px 22px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.skill-group-number {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 26px;\n  height: 26px;\n  border-radius: 999px;\n  background: #eef2ff;\n  color: #4338ca;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.skill-group-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.4;\n  color: #334155;\n}\n\n.skill-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.skill-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 18px;\n  width: 100%;\n  padding: 16px 22px;\n  background: #ffffff;\n  border: 0;\n  border-bottom: 1px solid #f1f5f9;\n  color: #0f172a;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.skill-row:last-child {\n  border-bottom: 0;\n}\n\n.skill-row:not(:disabled):hover {\n  background: #f8fafc;\n}\n\n.skill-row:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.skill-row-main {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.skill-row-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.skill-row-marker {\n  flex-shrink: 0;\n  padding: 3px 7px;\n  border-radius: 6px;\n  background: #e0e7ff;\n  color: #3730a3;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.skill-row-name {\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.35;\n}\n\n.skill-row-progress {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  max-width: 320px;\n}\n\n.skill-row-track {\n  flex: 1;\n  height: 6px;\n}\n\n.skill-row-count {\n  font-size: 12px;\n  font-weight: 700;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.skill-status {\n  flex-shrink: 0;\n  padding: 5px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.skill-status-done {\n  background: #ecfdf5;\n  color: #047857;\n}\n\n.skill-status-active {\n  background: #fffbeb;\n  color: #b45309;\n}\n\n.skill-status-todo {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n@media (max-width: 720px) {\n  .hero-title {\n    font-size: 34px;\n  }\n\n  .hero-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .path-card {\n    grid-template-columns: 32px minmax(0, 1fr);\n  }\n\n  .path-card-cta {\n    grid-column: 2;\n  }\n\n  .skill-row {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n/* ── Topics Page ────────────────────────────────────────────────────────────── */\n.topics-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.topic-section {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);\n  transition: box-shadow 0.2s ease;\n}\n\n.topic-section:hover {\n  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);\n}\n\n.topic-section-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 18px;\n  border-bottom: 1px solid transparent;\n}\n\n.topic-section:has(.problem-list) .topic-section-header {\n  border-bottom-color: #f1f5f9;\n}\n\n.topic-section-toggle {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  padding: 0;\n  color: #0f172a;\n  font-family: inherit;\n  min-width: 0;\n}\n\n.topic-section-toggle:hover .topic-section-name {\n  color: #4338ca;\n}\n\n.topic-caret {\n  font-size: 14px;\n  color: #94a3b8;\n  flex-shrink: 0;\n  width: 16px;\n}\n\n.topic-section-name {\n  font-size: 15px;\n  font-weight: 700;\n  flex: 1;\n  transition: color 0.15s ease;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.topic-section-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.topic-grade-badge {\n  font-size: 11px;\n  font-weight: 600;\n  color: #4338ca;\n  background: #eef2ff;\n  border: 1px solid #c7d2fe;\n  border-radius: 999px;\n  padding: 2px 10px;\n  white-space: nowrap;\n}\n\n.topic-question-count {\n  font-size: 12px;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.topic-section-source-btns {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.topic-section-practice-btn {\n  padding: 8px 16px;\n  font-size: 13px;\n  flex-shrink: 0;\n}\n\n/* ── Problem list ───────────────────────────────────────────────────────────── */\n.problem-list {\n  padding: 4px 0 8px;\n}\n\n.problem-list-empty {\n  padding: 12px 18px;\n  color: #94a3b8;\n  font-size: 14px;\n}\n\n.problem-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 10px 18px;\n  border-top: 1px solid #f1f5f9;\n  transition: background 0.12s ease;\n}\n\n.problem-row:hover {\n  background: #f8fafc;\n}\n\n.problem-index {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  color: #64748b;\n  margin-top: 1px;\n}\n\n.problem-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.problem-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  display: block;\n  margin-bottom: 3px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.problem-text {\n  font-size: 14px;\n  color: #0f172a;\n  margin: 0;\n  line-height: 1.5;\n  white-space: pre-wrap;\n}\n\n/* ── Empty practice state ───────────────────────────────────────────────────── */\n.empty-practice-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 80px 20px;\n  text-align: center;\n}\n\n.empty-practice-state h2 {\n  font-size: 22px;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 0;\n}\n\n.empty-practice-state p {\n  color: #475569;\n  margin: 0;\n  font-size: 15px;\n}\n\n.empty-practice-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 8px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n/* ── Responsive ─────────────────────────────────────────────────────────────── */\n@media (max-width: 640px) {\n  .app-nav {\n    padding: 0 16px;\n  }\n  .workspace,\n  .browse-page-container {\n    padding: 20px 16px;\n  }\n  .topic-cards-grid {\n    grid-template-columns: 1fr;\n  }\n  .major-topic-header {\n    padding: 18px;\n  }\n  .sub-topic-row {\n    grid-template-columns: 32px minmax(0, 1fr);\n    padding: 14px 18px;\n  }\n  .sub-topic-count {\n    grid-column: 2;\n  }\n  .goal-section-list {\n    padding: 0 18px 14px 50px;\n  }\n  .goal-section-row {\n    grid-template-columns: 1fr;\n    gap: 4px;\n  }\n  .topic-section-meta {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
